import { render, staticRenderFns } from "./MenuMobileCollapseItem.vue?vue&type=template&id=3b9b90e0&scoped=true"
import script from "./MenuMobileCollapseItem.vue?vue&type=script&lang=js"
export * from "./MenuMobileCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./MenuMobileCollapseItem.vue?vue&type=style&index=0&id=3b9b90e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b90e0",
  null
  
)

export default component.exports